module.exports = __webpack_public_path__ + "img/个性化鞋履定制.66ff2fba.png";